import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PlusOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusOutlined";
import AntdIcon from "../components/AntdIcon";
var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PlusOutlined.displayName = 'PlusOutlined';
}
export default /*#__PURE__*/React.forwardRef(PlusOutlined);